export default __webpack_public_path__ + "static/media/PPNeueMontreal-Book.165ed63c.woff";